export default async (to, from, next) => {
  try {
    const idx = window.location.toString().indexOf("#_=_");
    if (idx < 0) {
      return;
    }
    window.location = window.location.toString().substring(0, idx);
  } finally {
    next();
  }
};
